<template>
    <BContainer>
        <BAlert show dismissible class="custom-notification">
            <template v-slot:dismiss>
                <img src="~@/assets/pack_go/dismiss-icon.svg"/>
            </template>
            <p class="notification-label text-center">Congratulations! Your document has been successfully printed.</p>
        </BAlert>
        <div class="container">
            <img class="centered-image" src="~@/assets/pack_go/print-image.jpg"/>
            <router-link to="/pack-go">
                <BButton class="btn-css">
                    <img src="~@/assets/pack_go/reload-icon.svg"/>
                    Replay this demo
                </BButton>
            </router-link>
        </div>
    </BContainer>
</template>

<script>
import { BAlert, BButton, BContainer } from 'bootstrap-vue';

export default {
    components: {
        BButton,
        BContainer,
        BAlert
    }
}
</script>

<style>
.container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding-bottom: 91px;
}

.centered-image {
    width: 447px;
    height: 622px;
    margin-top: 30px;
}

@media (max-width: 768px) {
    .centered-image {
        width: 347px;
        height: 477px;
        margin-top: 30px;
    }
}

.btn-css {
    margin-top: 60px;
    margin-left: auto;
    margin-right: auto;
    align-items: center;
    padding: 20px 30px;
    background: #112857;
    border-radius: 6px;
    font-family: 'Source Sans Pro';
    font-style: normal;
    font-weight: 600;
    font-size: 18px;
    line-height: 23px;
    text-align: center;
}

.custom-notification {
    position: fixed;
    top: 50px;
    padding-right: 50px;
    background: #DDFFEB;
    border: 1px solid #04B14B;
    border-radius: 8px;
}

.notification-label {
    padding-top: 30px;
    padding-bottom: 10px;
    padding-left: 20px;
    font-family: 'Source Sans Pro';
    font-style: normal;
    font-weight: 600;
    font-size: 18px;
    line-height: 23px;
    text-align: right;
    color: #4E7960;
}
</style>